export default "__VITE_ASSET__35db18d9__"